import React, { PureComponent } from 'react';
import { MeasureId, MeasureType, TimePeriod, TrafficVolumeLocationDto } from 'app/model/CORE';
import { ModalHandler } from 'app/components/panels/ModalHandler';
import { PopoverMenu } from 'app/components/common/PopoverMenu';
import { MoreOutlined } from '@ant-design/icons';
import AppContext from 'app/common/context/AppContext';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { MonitoredEvent } from 'app/model/SOL49';
import Utils from 'app/common/util/Utils';
import { MonitoredEventType, MonitoredEventUtils } from 'app/common/util/MonitoredEventUtils';
import { OpenTvMonitoredEvents } from 'app/common/eventbus/Events';
import { ApplicableScenarioMenuUtils, ScenarioMenuState } from '../../common/ApplicableScenarioMenuUtils';

export interface MeasureMoreMenuProps {
    measureId: MeasureId;
    applicability: TimePeriod;
    tvLoc?: TrafficVolumeLocationDto;
    events?: Array<MonitoredEvent>;
}

interface MeasureMoreMenuState extends ScenarioMenuState {}

export class MeasureMoreMenu extends PureComponent<MeasureMoreMenuProps, MeasureMoreMenuState> {
    constructor(props: MeasureMoreMenuProps) {
        super(props);
        this.state = {
            isApplicableScenarioLoading: false,
        };
    }

    handleMoreMenuItemClick = (key: string) => {
        const { id, refLocation, tvSetIds } = this.props.tvLoc;
        switch (key) {
            case 'open-edit':
                ModalHandler.showRegulationEditor(this.props.measureId?.id, 'reg');
                break;
            case 'slot-list':
                ModalHandler.showSlotList(this.props.measureId);
                break;
            case 'interaction-study':
                ModalHandler.showInteractionStudy(this.props.measureId);
                break;
            case 'oplog':
                ModalHandler.showMeasureOpLog(this.props.measureId);
                break;
            case 'notes':
                OpenTvMonitoredEvents.fire(MonitoredEventType.NOTE, id, refLocation, tvSetIds, [
                    this.props.measureId?.id,
                ]);
                break;
            case 'events':
                OpenTvMonitoredEvents.fire(MonitoredEventType.WEATHER_EVENT, id, refLocation, tvSetIds, [
                    this.props.measureId?.id,
                ]);
                break;
        }
    };
    render() {
        const menuItems: ItemType[] = [];
        menuItems.push({
            key: 'open-edit',
            disabled: this.props.measureId?.type === MeasureType.REROUTING,
            label: `Open/edit ${this.props.measureId?.id}`,
        });
        if (AppContext.isNmvpBaseline())
            menuItems.push({
                key: 'slot-list',
                disabled: this.props.measureId?.type === MeasureType.REROUTING,
                label: 'Show slot list',
            });
        menuItems.push({ key: 'oplog', label: 'Show Op Log' });
        menuItems.push({ key: 'divider-1', type: 'divider' });
        menuItems.push({
            key: 'interaction-study',
            label: 'Interaction study',
            disabled: this.props.measureId?.type === MeasureType.REROUTING,
        });
        if (this.props.tvLoc?.refLocation?.refId) {
            menuItems.push({ key: 'divider-2', type: 'divider' });
            menuItems.push(
                ApplicableScenarioMenuUtils.applicableScenarioMenu(
                    [this.props.tvLoc.id],
                    this.props.applicability,
                    this.state,
                    (state: MeasureMoreMenuState) => this.setState(state),
                ),
            );
        }

        const notes = this.props.events?.filter(MonitoredEventUtils.isNoteEvent);
        const events = this.props.events?.filter(MonitoredEventUtils.isWeatherEvent);
        menuItems.push({ key: 'notes', label: `${Utils.isNotEmpty(notes) ? 'Show notes' : 'Add a note'}` });
        menuItems.push({ key: 'events', label: `${Utils.isNotEmpty(events) ? 'Show events' : 'Add an event'}` });

        return (
            <PopoverMenu onMenuItemClick={this.handleMoreMenuItemClick} menuItems={menuItems}>
                <MoreOutlined />
            </PopoverMenu>
        );
    }
}
